<template>
  <div class="hello">
    <h1>{{ msg }}</h1>

    <div class='container'>
      <div class='row' v-bind:key="row.id" v-for="row in results">{{ row }}</div>
      <button v-on:click="loadData">Recarregar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data: function() {
    return {
      results: {}
    };
  },
  created: function() {
    this.loadData();
  },
  methods: {
    async loadData() {
      console.log("inicio");
      const r = await fetch("http://3.136.82.117:81/user");
      this.results = await r.json();
      console.log(this.results);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
